import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { IconButton, Message, Panel, Row, Icon } from 'rsuite'
import ChkAreaSetting from './ChkAreaSetting'
import ChkAreaSettingView from './ChkAreaSettingView'

import scrollToComponent from 'react-scroll-to-component'
import { Controller, useForm } from 'react-hook-form'
import {
  updateSubProjectTargetSetting,
  updateTargetSetting,
} from '../../../redux/actions/targetSetting'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { saveConfirmActualResult } from '../../../redux/actions/closeOfProject'

export default function ChkAreaSettingWidget(props) {
  const {
    showCommandButton,
    schema,
    checked,
    isConfirmActualResult = false,
    isEdit,
    onChangeIsEdit,
    isSubProject,
    numberOfInstallment,
    onSuccess = () => {},
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema)

  const handleUpdateTargetSetting = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateTargetSetting(projectId, request)
      if (response.success) {
        setFormSchema(response.model)
        onChangeIsEdit(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateTargetSettingSubProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateSubProjectTargetSetting(projectId, request)
      // if (response.success) {
      setFormSchema(response)
      onChangeIsEdit(false)
      await dispatch(getSchemaSubProjectSidebar(projectId))
      // } else {
      // setIsError(true)
      // }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let selected = data.issuesSelected
    const index = selected?.indexOf('OTHER')
    if (index > -1) {
      selected.splice(index, 1)
    }

    let request = {
      areaCriteria: data.areaCriteria,
      disabledAllCheckbox: data.disabledAll ? true : false,
      optionSelected: selected,
      inputOther: data.inputOther,
      numberOfInstallment: numberOfInstallment,
    }

    if (isSubProject) {
      handleUpdateTargetSettingSubProject(request)
    } else {
      handleUpdateTargetSetting(request)
    }
  }

  const onSubmitConfActualResult = (data) => {
    console.log('onSubmitConfActualResult => ', data)

    let selected = data?.issuesSelected?.map((v) => (v === 'OTHER' ? '9999' : v))
    // let selected = data.issuesSelected
    // const index = selected?.indexOf('OTHER')
    // if (index > -1) {
    //   selected.splice(index, 1)
    // }

    // let request = {
    //   areaCriteria: data.areaCriteria,
    //   disabledAllCheckbox: data.disabledAll ? true : false,
    //   optionSelected: selected,
    //   inputOther: data.inputOther,
    // }

    let request = {
      optionSelected: selected,
      inputOther: data.disabledAll ? 'IsNotSpatial' : data.inputOther,
      confType: 'TargetSettings',
      targetLists: null,
      numberOfInstallment: numberOfInstallment,
      inputCriteria: data.areaCriteria,
      year: null,
      version: null,
    }

    console.log('request => ', request)
    handleSaveConfirmActualResult(request)
  }

  const handleSaveConfirmActualResult = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveConfirmActualResult(projectId, request)
      console.log('response : ', response)
      if (response.success) {
        onSuccess(true)

        // const saveResp = await getCloseOfProjectCoworkerForm(projectId)
        //
        // let _formSchema = cloneDeep(formSchema)
        //
        // _formSchema.optionSelected = saveResp?.forms?.confirmActualResul?.goal?.goalTenYear?.optionSelected || null
        //
        // setCheckedConf(saveResp?.forms?.confirmActualResulChecked?.goalTenYearChecked || null)
        // setFormSchema(_formSchema)

        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        onSuccess(false)
      }
    } catch (e) {
      setIsError(true)
      onSuccess(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  const chkAreaSettingForm = (
    <ChkAreaSetting
      schema={formSchema}
      register={register}
      Controller={Controller}
      control={control}
      errors={errors}
      setValue={setValue}
      clearErrors={clearErrors}
      getValues={getValues}
      column={3}
      isConfirmActualResult={isConfirmActualResult}
    />
  )

  const chkAreaSettingView = <ChkAreaSettingView schema={formSchema} column={3} />

  return (
    <Panel
      shaded={!isConfirmActualResult}
      bordered={!!isConfirmActualResult}
      header={formSchema.header}
      defaultExpanded
      collapsible
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? chkAreaSettingForm : chkAreaSettingView}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              {isError && (
                <Row style={{ marginBottom: 10 }}>
                  <Message
                    showIcon
                    type="error"
                    description={
                      'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                    }
                  />
                </Row>
              )}

              {isConfirmActualResult ? (
                <>
                  {checked && (
                    <Message
                      showIcon
                      type={checked.checkedType ? 'success' : 'error'}
                      description={
                        <div dangerouslySetInnerHTML={{ __html: checked.detail || '' }} />
                      }
                      style={{ marginBottom: 10 }}
                    />
                  )}

                  <SaveButton
                    icon="views-authorize"
                    onClick={handleSubmit(onSubmitConfActualResult)}
                    // disabled={!!checked?.checkedType || isLoading}
                    disabled={isLoading}
                    children={'ยืนยันการดำเนินการจริง'}
                  />
                </>
              ) : (
                <>
                  <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
                  <CancelButton
                    onClick={() => {
                      onChangeIsEdit(!isEdit)
                    }}
                    disabled={isLoading}
                  ></CancelButton>
                </>
              )}
            </div>
          ) : (
            <>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-edit"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                icon={<Icon className="bt-gost-icon-radius-edit" icon="plus" />}
              >
                แก้ไข{formSchema.header}
              </IconButton>

              {/*<EditButton*/}
              {/*  onClick={() => {*/}
              {/*    onChangeIsEdit(!isEdit)*/}
              {/*    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })*/}
              {/*  }}*/}
              {/*>*/}
              {/*  แก้ไข{formSchema.header}*/}
              {/*</EditButton>*/}
            </>
          )}
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header: 'พื้นที่ดำเนินการ (setting)',
//   areaCriteria: {
//     alert:
//       'กรอกเกณฑ์การคัดเลือกที่สะท้อนการเป็นตัวแทนที่เหมาะสมที่จะสร้างเป็นต้นแบบที่ดีได้อย่างชัดเจน (ท่านสามารถ ใส่ข้อความได้ 1000 ตัวอักษร)',
//     label: 'เกณฑ์การคัดเลือกพื้นที่ดำเนินการ',
//     hint: 'ระบุเกณฑ์การคัดเลือก',
//     name: 'areaCriteria',
//     value: '',
//     validators: [
//       {
//         type: 'REQUIRED',
//         errorMessage: 'กรุณากรอก เกณฑ์การคัดเลือกกลุ่มเป้าหมาย',
//       },
//       {
//         type: 'MAXLENGTH',
//         value: 1000,
//         errorMessage: 'ข้อความเกินกำหนด',
//       },
//     ],
//   },
//   areaSetting: {
//     name: 'areaSetting',
//     alert: 'เลือกได้มากกว่า 1 ข้อ',
//     // column: 3,
//     // columnView: 1,
//     disabledAllCheckbox: {
//       value: '',
//       label: 'ไม่ใช่งานเชิงพื้นที่',
//     },
//     optionSelected: [],
//     options: [
//       {
//         name: 'checkbox1',
//         value: 1,
//         label: '1. โรงเรียน',
//       },
//       {
//         name: 'checkbox2',
//         value: 2,
//         label: '2. มหาวิทยาลัย',
//       },
//       {
//         name: 'checkbox3',
//         value: 3,
//         label: '3. นอกโรงเรียน (กศน.)',
//       },
//       {
//         name: 'checkbox4',
//         value: 4,
//         label: '4. อาชีวะ',
//       },
//       {
//         name: 'checkbox5',
//         value: 5,
//         label: '5.  ศูนย์เด็กเล็ก',
//       },
//       {
//         name: 'checkbox6',
//         value: 6,
//         label: '6. สถานศึกษาอื่น ๆ',
//       },
//       {
//         name: 'checkbox7',
//         value: 7,
//         label: '7. โรงพยาบาล',
//       },
//       {
//         name: 'checkbox8',
//         value: 8,
//         label: '8. รพสต./สถานีอนามัย',
//       },
//       {
//         name: 'checkbox9',
//         value: 9,
//         label: '9. ศูนย์สุขภาพชุมชน',
//       },
//       {
//         name: 'checkbox10',
//         value: 10,
//         label: '10. สถานพยาบาลอื่น ๆ',
//       },
//       {
//         name: 'checkbox11',
//         value: 11,
//         label: '11. สถานประกอบการ/โรงงาน/บริษัทเอกชน',
//       },
//       {
//         name: 'checkbox12',
//         value: 12,
//         label: '12. ชุมชน',
//       },
//       {
//         name: 'checkbox13',
//         value: 13,
//         label: '13. องค์กร/หน่วยงานรัฐอื่น ๆ',
//       },
//       {
//         name: 'checkbox14',
//         value: 14,
//         label: '14. ศาสนสถาน (วัด, โบสถ์, มัสยิด)',
//       },
//       {
//         name: 'checkbox15',
//         value: 15,
//         label: '15. อื่น ๆ (นอกจาก 10 ข้อข้างต้น)',
//       },
//     ],
//     validators: [
//       {
//         type: 'REQUIRED',
//         errorMessage: 'กรุณาเลือก อย่างน้อย 1 รายการ',
//       },
//     ],
//     inputOther: {
//       name: 'inputOther',
//       value: '',
//       label: 'โปรดระบุ',
//     },
//   },
// }
